import { render, staticRenderFns } from "./GuestToolbar.vue?vue&type=template&id=03fa3b88&scoped=true"
import script from "./GuestToolbar.vue?vue&type=script&lang=js"
export * from "./GuestToolbar.vue?vue&type=script&lang=js"
import style0 from "./GuestToolbar.vue?vue&type=style&index=0&id=03fa3b88&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fa3b88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03fa3b88')) {
      api.createRecord('03fa3b88', component.options)
    } else {
      api.reload('03fa3b88', component.options)
    }
    module.hot.accept("./GuestToolbar.vue?vue&type=template&id=03fa3b88&scoped=true", function () {
      api.rerender('03fa3b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/GuestToolbar.vue"
export default component.exports